<template>
  <div>
    <div v-if="enabledSportsSite === 'Soccer' && currentUser.soccer_sports">
      <div class="card-content card-img">
        <img class="w-100" :src="soccerImage" />
      </div>
    </div>
    <div v-else-if="enabledSportsSite === 'Hockey' && currentUser.hockey_sports">
      <div class="card-content card-img">
        <img class="w-100" :src="hockeyImage" />
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      currentUser: {
        type: Object,
        required: true
      },
      enabledSportsSite: {
        type: String,
        required: true
      }
    },
    computed: {
      soccerImage() {
        return this.currentUser.language === 'ENGLISH'
          ? require('../../assets/images/english_soccer.jpg')
          : require('../../assets/images/french_soccer.jpg');
      },
      hockeyImage() {
        return this.currentUser.language === 'ENGLISH'
          ? require('../../assets/images/timbits-hockey.png')
          : require('../../assets/images/french_hockey.jpg');
      }
    }
  };
</script>
